import React from 'react';

const VideoGroupsBanner = (props) => {
    const { videoSource, left } = props;
    return (

        <video loop muted autoPlay className={`w-full h-full object-cover fixed -left-[${left}]`}>
            <source src={videoSource} type="video/mp4" />
        </video>

    );
}

export default VideoGroupsBanner;